import $ from 'jquery';
import mapboxgl from '!mapbox-gl';

import { changeExaggeration, clearMarkers, defaultParcellaireColor, flyTo, getPageData, initLightboxes, map, mapInitialized, mapMarkers, parcellairesColors } from './main';
import { $Elements, Classes } from '../global/constants';
import { wait } from '../global/helpers';

let showParcellaires = false;
let showIcons = false;

export function propertyEnter() {

	if(map) {
		if(mapInitialized) {
			initMarkers();
		}
		else {
			$Elements.document.on('map.initialized', initMarkers);
		}
	}
}

export function propertyLeave() {
	clearMarkers();
}

async function initMarkers() {

	const data = getPageData();

	if(data) {

		if(data.icons) {

			for(const marker of data.icons.markers) {

				const markerElement = $(marker.marker);

				mapMarkers.push(new mapboxgl.Marker({
					element: markerElement[0],
					anchor: 'bottom',
				}).setLngLat(marker.coordinates).addTo(map));
			}

			showIcons = false;

			$('.toggle-icons').click(() => {

				showIcons = !showIcons;

				if(showIcons) {
					$('.toggle-icons, .icon-marker').addClass(Classes.active);
				}
				else {
					$('.toggle-icons, .icon-marker').removeClass(Classes.active);
				}
			});
		}

		initLightboxes();

		if(data.property) {

			changeExaggeration(data.property.exaggeration);

			map.setPaintProperty(data.property.parcellaire, 'fill-opacity', 1);

			if(data.property.other_parcellaire) {
				map.setPaintProperty(data.property.other_parcellaire, 'fill-opacity', 1);
			}

			for(const location of data.property.flyto) {
				await flyTo(location);
			}

			showParcellaires = false;

			$('.toggle-parcellaire').click(() => {

				showParcellaires = !showParcellaires;

				if(showParcellaires) {
					map.setPaintProperty(data.property.parcellaire, 'fill-color', parcellairesColors);

					if(data.property.other_parcellaire) {
						map.setPaintProperty(data.property.other_parcellaire, 'fill-color', parcellairesColors);
					}

					$('.toggle-parcellaire, .cepages').addClass(Classes.active);
				}
				else {
					map.setPaintProperty(data.property.parcellaire, 'fill-color', defaultParcellaireColor);

					if(data.property.other_parcellaire) {
						map.setPaintProperty(data.property.other_parcellaire, 'fill-color', defaultParcellaireColor);
					}

					$('.toggle-parcellaire, .cepages').removeClass(Classes.active);
				}
			});
		}
	}
}
